// extracted by mini-css-extract-plugin
export default {"mid":"Mid_mid__CecPQ","left":"Mid_left__o4wm+","right":"Mid_right__5lWUm","rightLine":"Mid_rightLine__lBiHj"};